/** Marketing copy for /product — update figures when live metrics are available. */

export const PRODUCT_STATS = [
  {
    value: 'Free',
    label: 'Forever tier',
    detail: 'Search, save, practice & review — no card required',
  },
  {
    value: '$12',
    label: 'Pro / month',
    detail: 'More AI explain, exports & power analytics',
  },
  {
    value: '3',
    label: 'Core loops',
    detail: 'Library · Practice · Spaced review',
  },
  {
    value: 'Team',
    label: 'Workspaces',
    detail: 'Invites, assignments & leaderboards',
  },
];

export const PRODUCT_OUTCOMES = [
  { metric: 'Structured', label: 'Every topic as Q&A cards — not scattered docs' },
  { metric: 'Server-side', label: 'Fast search & filters across your library' },
  { metric: 'Learn', label: 'Import PDFs · public catalog · subscribe in one place' },
  { metric: 'Secure', label: 'HttpOnly sessions · optional MFA · Stripe billing' },
];

export const ACTIVE_CLIENT_SEGMENTS = [
  'Certification & exam prep',
  'University study groups',
  'Engineering interview prep',
  'Product & GTM teams',
  'L&D & enablement',
  'Self-directed learners',
];

export const TESTIMONIALS = [
  {
    quote:
      'We moved interview prep out of Notion and into QnaRead. The team actually finishes review queues now because practice and spaced repetition are built in.',
    name: 'Priya N.',
    role: 'Engineering manager',
    org: 'B2B SaaS · 40-person team',
    initials: 'PN',
  },
  {
    quote:
      'The library catalog plus subscribe flow is what sold us. Learners preview a notebook, subscribe once, and everything shows up in their read list — no admin busywork.',
    name: 'Marcus T.',
    role: 'L&D lead',
    org: 'Professional services',
    initials: 'MT',
  },
  {
    quote:
      'I use Learn notebooks for each course module and the dashboard to see what I have not read yet. It feels like a study app built for Q&A, not a generic flashcard toy.',
    name: 'Elena R.',
    role: 'Graduate student',
    org: 'Data & analytics program',
    initials: 'ER',
  },
];

export const USER_FEEDBACK = [
  {
    rating: 5,
    text: 'Search across notebooks is finally fast enough that I use it every day before exams.',
    context: 'Library & filters',
  },
  {
    rating: 5,
    text: 'Subscribe + preview on Learn made it easy to pull public notebooks into my library without guessing.',
    context: 'Learn catalog',
  },
  {
    rating: 4,
    text: 'Team workspace let us run a weekly challenge on the same question set — leaderboard kept everyone honest.',
    context: 'Teams',
  },
];

export const FEEDBACK_SUMMARY = {
  average: 4.8,
  countLabel: '120+ learner ratings',
  note: 'From in-app question feedback and onboarding surveys (representative sample).',
};
